import { render, staticRenderFns } from "./material.vue?vue&type=template&id=c61318a0&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=c61318a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61318a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c61318a0')) {
      api.createRecord('c61318a0', component.options)
    } else {
      api.reload('c61318a0', component.options)
    }
    module.hot.accept("./material.vue?vue&type=template&id=c61318a0&scoped=true", function () {
      api.rerender('c61318a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_image/material.vue"
export default component.exports